const statCountersArray = document.querySelectorAll('.js-stat-counter');
const interval = 700;
statCountersArray.forEach(statCounter => {
  setTimeout(() => {
    let startValue = 0;
    const endValue = parseInt(statCounter.getAttribute('data-value'));
    const duration = Math.floor(interval / endValue);
    const counter = setInterval(function() {
      startValue += 1;
      statCounter.textContent = startValue;
      if (startValue == endValue) {
        clearInterval(counter);
      }
    }, duration);
  }, 1000);
});
